import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
//import 'bootstrap/dist/css/bootstrap.css'

const app = createApp(App)
app.mount('#app')
